import React, { useEffect, useState } from "react";
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    Grid2,
    Container,
    Link,
    useTheme
} from "@mui/material";
import pwcLogo from "assets/Wrap.png";
import { CiCircleCheck } from "react-icons/ci";

const WorkFlowSuccessed = () => {

    const newtheme = useTheme();
    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            {/* Top App Bar */}
            <AppBar position="static" sx={{ backgroundColor: "#fff", boxShadow: "none" }}>
                <Toolbar>
                    <img src={pwcLogo} style={{ width: "7%" }} alt="Logo" />
                </Toolbar>
            </AppBar>

            <Grid2 container spacing={2} sx={{ flexGrow: 1, display: "flex", justifyContent: "center", backgroundColor: "#f3f3f3", p: 4 }}>
                <Grid2 sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 4
                }}>
                    <CiCircleCheck style={{
                        fontSize: '10rem',
                        color: `${newtheme?.customSettings?.themeColor}`
                    }} />
                    <Typography
                        variant="h3"
                        gutterBottom
                        style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginTop: "20px" }}
                    >
                        Issue submitted successfully
                    </Typography>

                </Grid2>
            </Grid2>

            {/* Footer */}
            <Box sx={{ py: 2, backgroundColor: "#f5f5f5", textAlign: "center" }}>
                <Container>
                    <Typography variant="caption" sx={{ color: "#252525", fontSize: "14px" }}>
                        Version: V1.2025 <br />
                        © 2025 PwC (RAD App Local). All rights reserved.
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                        <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                            Legal Disclaimers
                        </Link>
                        |
                        <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                            Contact Support
                        </Link>
                        |
                        <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                            Click me!
                        </Link>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default WorkFlowSuccessed;
